import React from 'react';
import { useTranslation } from 'react-i18next';

import { PageTitle } from './PageTitle.jsx';

import { AppContext } from '../AppContext';

const MoreGames = () => {
	const { t } = useTranslation();
	const app = React.useContext(AppContext);
	const marketPlace = app.marketPlace;

	React.useEffect(() => {
		app.achievements.awardAchivement(app.userdata, 'See More Games');
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const showGame = React.useCallback((name) => {
		console.log(`show game ${name}`);
		marketPlace.show(name);
	}, [marketPlace]);

	const games = marketPlace.getGames();

	const listItems = games.map((game) =>
		<li key={game.name} className={'button button' + game.name} onClick={() => showGame(game.name)}>{t(game.name)}</li>,
	);

	return (
		<div id="MoreGames" className="page1 paddingTop50">
			<div className="wrapper">
				<PageTitle>
					<h1>{t('More Games')}</h1>
				</PageTitle>

				<div className='content-narrow'>
					<ul className='buttonList'>
						{listItems}
					</ul>
				</div>
			</div>
		</div >
	);
};

export default React.memo(MoreGames);
